import { render } from "./CxMultiMessage.vue?vue&type=template&id=398c6f28"
import script from "./CxMultiMessage.vue?vue&type=script&lang=js"
export * from "./CxMultiMessage.vue?vue&type=script&lang=js"

import "./CxMultiMessage.vue?vue&type=style&index=0&id=398c6f28&lang=less"

import exportComponent from "/home/ec2-user/workspace/_conx-ui-monorepo_ui2_lab_master/apps/ui2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__